import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { withProps } from 'recompose'

import GridView from './GridView'
// import FormView from './FormView'

// const FormComponent = withProps(({ match }) => ({
//   id: match.params.id
// }))(FormView)

export default ({ match }) => (
  <Switch>
    {/* <Route path={`${match.path}/:id`} component={FormComponent} /> */}
    <Route path={`${match.path}/`} component={GridView} />
  </Switch>
)
